import React from 'react';
import { Layers, Search, ArrowUpCircle, PlusCircle, Package, ChevronRight, CheckCircle, AlertCircle, ShieldCheck } from 'lucide-react';
import Pagination from '../../components/Layout/Pagination';

function InventoryTab({
  items, totalItems, currentPage, setCurrentPage, searchTerm, setSearchTerm,
  handleExportInventory, setShowAddModal, setSelectedGroup,
  inventoryFilter, setInventoryFilter
}) {
  return (
    <div className="space-y-6">
      <div className="flex gap-4">
        {[
          { id: 'all', label: 'BARCHA TOVARLAR', icon: <Layers size={18}/>, color: 'blue' },
          { id: 'verified', label: 'TEKSHIRILGANLAR (FULL ID)', icon: <CheckCircle size={18}/>, color: 'emerald' },
          { id: 'unverified', label: 'TEKSHIRILMAGANLAR', icon: <AlertCircle size={18}/>, color: 'rose' }
        ].map(f => (
          <button
            key={f.id}
            onClick={() => { setInventoryFilter(f.id); setCurrentPage(1); }}
            className={`flex-1 flex items-center justify-center gap-3 py-5 rounded-[25px] font-black text-xs tracking-widest transition-all border-2 ${
              inventoryFilter === f.id
              ? `bg-${f.color}-500/10 border-${f.color}-500/50 text-${f.color}-400 shadow-lg shadow-${f.color}-500/10`
              : 'bg-slate-900 border-white/5 text-slate-500 hover:border-white/10'
            }`}
          >
            {f.icon} {f.label}
          </button>
        ))}
      </div>

      <div className="bg-slate-900 rounded-[45px] shadow-2xl border border-blue-500/10 overflow-hidden">
        <div className="p-8 border-b border-white/5 flex justify-between items-center">
          <div className="font-black text-2xl flex items-center gap-3 text-white">
            <Package className={inventoryFilter === 'verified' ? 'text-emerald-400' : (inventoryFilter === 'unverified' ? 'text-rose-400' : 'text-blue-400')} size={28}/>
            Sklad {inventoryFilter === 'verified' && <span className="text-emerald-500/50 text-sm ml-2">(Aniq Qoldiq)</span>}
          </div>
          <div className="flex gap-4 items-center">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18}/>
              <input type="text" placeholder="Nom yoki Markirovka..." className="pl-12 pr-6 py-4 bg-slate-950 border border-white/5 rounded-[25px] w-96 outline-none focus:ring-2 focus:ring-blue-500/20 font-bold text-white" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
            </div>
            <button onClick={handleExportInventory} className="bg-emerald-600 text-white px-6 py-4 rounded-[25px] font-black flex items-center gap-2 hover:bg-emerald-700 transition shadow-[0_0_20px_rgba(16,185,129,0.3)]">
              <ArrowUpCircle size={20}/> OMBORNI EKSPORT QILISH
            </button>
            <button onClick={() => setShowAddModal(true)} className="bg-blue-600 text-white px-6 py-4 rounded-[25px] font-black flex items-center gap-2 hover:bg-blue-700 transition shadow-[0_0_20px_rgba(37,99,235,0.3)]">
              <PlusCircle size={20}/> YANGI TOVAR QO'SHISH
            </button>
          </div>
        </div>
        <table className="w-full text-left">
          <thead>
            <tr className="text-[11px] font-black uppercase text-slate-500 bg-black/20">
              <th className="px-10 py-6 tracking-widest">Mahsulot</th>
              <th className="px-10 py-6 text-center tracking-widest">Soni</th>
              <th className="px-10 py-6 text-right tracking-widest">Tannarx (O'rtacha)</th>
              <th className="px-10 py-6 text-center tracking-widest">Detallar</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {items.map((g, idx) => (
              <tr key={idx} className="hover:bg-blue-600/5 transition cursor-pointer group" onClick={() => setSelectedGroup({ ...g, all: g.all_items })}>
                <td className="px-10 py-8 font-black text-slate-300 text-lg">
                  <div className="flex items-center gap-4">
                    <div className="relative">
                      {g.image_url ? (
                        <img src={g.image_url} alt="p" className="w-12 h-12 rounded-xl object-cover border border-white/10 shadow-lg" />
                      ) : (
                        <div className="w-12 h-12 rounded-xl bg-slate-800 flex items-center justify-center text-slate-500 border border-white/5"><Package size={20}/></div>
                      )}
                      {g.all_items?.some(i => i.is_verified) && (
                        <div className="absolute -top-2 -right-2 bg-emerald-500 text-slate-900 rounded-full p-1 border-2 border-slate-900">
                          <ShieldCheck size={10} />
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col">
                      <span>{g.product_name}</span>
                      <span className="text-[10px] text-slate-600 font-bold uppercase tracking-widest">{g.all_items?.filter(i => i.is_verified).length} ta tekshirilgan</span>
                    </div>
                  </div>
                </td>
                <td className="px-10 py-8 text-center"><span className="bg-blue-600 text-white px-5 py-2 rounded-full font-black text-xs shadow-[0_0_15px_rgba(37,99,235,0.4)]">{Number(g.count)} {g.unit || 'dona'}</span></td>
                <td className="px-10 py-8 text-right font-black text-xl text-blue-100">{Math.round(g.cost_price).toLocaleString()} <span className="text-xs text-slate-600">s</span></td>
                <td className="px-10 py-8 text-center text-slate-600 group-hover:text-blue-400 transition"><ChevronRight size={28} className="mx-auto" /></td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination totalItems={totalItems} itemsPerPage={50} currentPage={currentPage} onPageChange={setCurrentPage} />
      </div>
    </div>
  );
}

export default InventoryTab;
